import { createGqlSubscriptionApi } from '../create-subscription-api';
import {
  api as getOrganizationsApi,
  GetOrganizationsDocument,
} from '../queries/GetOrganizations.admin.generated';

export const api = createGqlSubscriptionApi(
  getOrganizationsApi,
  'GetOrganizations',
  GetOrganizationsDocument,
);

export const { useGetOrganizationsQuery: useGetOrganizationsQuerySubscription } = api;
